import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiShield, FiUsers, FiTrendingUp, FiGift, FiStar } = FiIcons;

const Features = () => {
  const features = [
    {
      icon: FiZap,
      title: 'Lightning Fast',
      description: 'Built on Solana for instant transactions and minimal fees',
      color: 'from-yellow-400 to-orange-500'
    },
    {
      icon: FiShield,
      title: 'Secure & Audited',
      description: 'Smart contract audited by top security firms',
      color: 'from-green-400 to-blue-500'
    },
    {
      icon: FiUsers,
      title: 'Strong Community',
      description: 'Join 100K+ holders in the PinkZilla army',
      color: 'from-pink-400 to-purple-500'
    },
    {
      icon: FiTrendingUp,
      title: 'Explosive Growth',
      description: 'Trending #1 on multiple platforms',
      color: 'from-red-400 to-pink-500'
    },
    {
      icon: FiGift,
      title: 'Rewards System',
      description: 'Earn rewards just for holding $PINKZILLA',
      color: 'from-purple-400 to-pink-500'
    },
    {
      icon: FiStar,
      title: 'Meme Power',
      description: 'Backed by the strongest meme community',
      color: 'from-indigo-400 to-purple-500'
    }
  ];

  return (
    <section id="features" className="py-20 px-4">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Why <span className="bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent">PinkZilla</span> is Different
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just another meme coin. We're building the future of community-driven crypto with real utility and explosive growth potential.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all border border-pink-100"
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${feature.color} flex items-center justify-center mb-6`}>
                <SafeIcon icon={feature.icon} className="text-white text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-3xl p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to Join the Revolution?</h3>
            <p className="text-lg mb-6 opacity-90">Don't miss out on the next 1000x meme coin opportunity!</p>
            <motion.a
              href="https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-pink-600 px-8 py-3 rounded-full font-bold text-lg inline-flex items-center space-x-2 hover:bg-pink-50 transition-all"
            >
              <SafeIcon icon={FiZap} />
              <span>Buy $PINKZILLA Now</span>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Features;